import { useState, useEffect } from 'react';
import { type AppManifest } from '@aid/shared';
import { fetchManifest } from './manifest-client';

export interface UseAppManifestResult {
  manifest: AppManifest | null;
  loading: boolean;
  error: string | null;
}

export function useAppManifest(): UseAppManifestResult {
  const [state, setState] = useState<UseAppManifestResult>({
    manifest: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setState({ manifest: null, loading: true, error: null });

      try {
        const manifest = await fetchManifest();

        if (!cancelled) {
          if (manifest) {
            setState({ manifest, loading: false, error: null });
          } else {
            setState({
              manifest: null,
              loading: false,
              error: 'Failed to load app manifest',
            });
          }
        }
      } catch (err) {
        if (!cancelled) {
          setState({
            manifest: null,
            loading: false,
            error: err instanceof Error ? err.message : 'Unknown error',
          });
        }
      }
    }

    void load();

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
